/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationAccessRecordsControllerFindAllQueryResponse, IntegrationAccessRecordsControllerFindAllQueryParams, IntegrationAccessRecordsControllerFindAll401, IntegrationAccessRecordsControllerFindAll403 } from "../../models/integrationAccessController/IntegrationAccessRecordsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { integrationAccessRecordsControllerFindAll } from "../../clients/integration-accessService/integrationAccessRecordsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const integrationAccessRecordsControllerFindAllQueryKey = (params: IntegrationAccessRecordsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/integration-access-records'
}, ...(params ? [params] : [])] as const;
export type IntegrationAccessRecordsControllerFindAllQueryKey = ReturnType<typeof integrationAccessRecordsControllerFindAllQueryKey>;
export function integrationAccessRecordsControllerFindAllQueryOptions(params?: IntegrationAccessRecordsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = integrationAccessRecordsControllerFindAllQueryKey(params);
  return queryOptions<IntegrationAccessRecordsControllerFindAllQueryResponse, ResponseErrorConfig<IntegrationAccessRecordsControllerFindAll401 | IntegrationAccessRecordsControllerFindAll403>, IntegrationAccessRecordsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return integrationAccessRecordsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List what Document Crunch read from integrations for the caller
 * {@link /api/v1/integration-access-records}
 */
export function useIntegrationAccessRecordsControllerFindAll<TData = IntegrationAccessRecordsControllerFindAllQueryResponse, TQueryData = IntegrationAccessRecordsControllerFindAllQueryResponse, TQueryKey extends QueryKey = IntegrationAccessRecordsControllerFindAllQueryKey>(params?: IntegrationAccessRecordsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<IntegrationAccessRecordsControllerFindAllQueryResponse, ResponseErrorConfig<IntegrationAccessRecordsControllerFindAll401 | IntegrationAccessRecordsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? integrationAccessRecordsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...integrationAccessRecordsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IntegrationAccessRecordsControllerFindAll401 | IntegrationAccessRecordsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}